// Central business info & content for Dr. Avril Dhar
export const CLINIC = {
  name: "Dr. Avril Dhar",
  title: "Neurologist & Psychologist",
  tagline: "Expert Mind. Compassionate Care.",
  taglineAlt: "Better Brain. Better Mind. Better Life.",
  phone: "+91 89683 03489",
  phoneRaw: "+918968303489",
  whatsapp: "https://wa.me/918968303489",
  email: "Dharavril9@gmail.com",
  location: "Chandigarh, India",
  hours: [
    { day: "Monday – Friday", time: "10:00 AM – 12:00 PM" },
    { day: "Monday – Friday", time: "3:00 PM – 5:00 PM" },
    { day: "Saturday – Sunday", time: "By Appointment" },
  ],
};

// Real uploaded doctor portrait (used in hero — shows only doctor via object-fit crop)
export const HERO_POSTER =
  "https://customer-assets.emergentagent.com/job_avril-dhar-md/artifacts/yoqm08tb_file_000000009c58720ba3acc2e1dbfabcc0.jpg";

export const IMAGES = {
  doctor_desk:
    "https://customer-assets.emergentagent.com/job_d961fd02-39a3-4d68-b5b7-28db785c86bc/artifacts/bcnkxrfl_IMG-20260514-WA0011.jpg",
  doctor_podium:
    "https://customer-assets.emergentagent.com/job_d961fd02-39a3-4d68-b5b7-28db785c86bc/artifacts/5a1wac6w_IMG-20260514-WA0018.jpg",
  group_coats:
    "https://customer-assets.emergentagent.com/job_d961fd02-39a3-4d68-b5b7-28db785c86bc/artifacts/nxlt21nt_IMG-20260514-WA0019.jpg",
  womens_day:
    "https://customer-assets.emergentagent.com/job_d961fd02-39a3-4d68-b5b7-28db785c86bc/artifacts/159x44sb_IMG-20260514-WA0016.jpg",
  selfie:
    "https://customer-assets.emergentagent.com/job_d961fd02-39a3-4d68-b5b7-28db785c86bc/artifacts/a7vthnqo_IMG-20260514-WA0013.jpg",
};

export const NEUROLOGY_SERVICES = [
  { icon: "Brain", title: "Headache & Migraine", desc: "Detailed evaluation and modern treatment for chronic headaches, tension headaches, and migraines." },
  { icon: "HeartPulse", title: "Stroke Care", desc: "Acute stroke management, secondary prevention and long-term rehabilitation planning." },
  { icon: "Activity", title: "Vertigo & Dizziness", desc: "Careful work-up for vestibular disorders, BPPV, and balance issues with targeted therapy." },
  { icon: "Zap", title: "Nerve Disorders", desc: "Diagnosis and management of peripheral nerve problems, weakness, tingling and numbness." },
  { icon: "Sparkles", title: "Memory Problems", desc: "Evaluation of memory complaints, early dementia and cognitive decline with personal care plans." },
  { icon: "Waves", title: "Parkinson's Disease", desc: "Considered medical management of Parkinson's and other movement disorders to restore quality of life." },
  { icon: "Stethoscope", title: "Neuropathy", desc: "Evaluation and treatment for diabetic, autoimmune, and idiopathic neuropathies." },
  { icon: "AlertCircle", title: "Seizures & Epilepsy", desc: "Long-term seizure management, medication optimization and lifestyle counseling." },
  { icon: "Bone", title: "Spine & Neck Pain", desc: "Targeted evaluation for nerve-related neck and back pain and radiating limb pain." },
];

export const PSYCHOLOGY_SERVICES = [
  { icon: "Wind", title: "Anxiety", desc: "Evidence-based therapy for generalized anxiety, social anxiety and excessive worry." },
  { icon: "CloudRain", title: "Depression", desc: "Compassionate support and structured care for low mood, fatigue and persistent sadness." },
  { icon: "AlertTriangle", title: "Panic Attacks", desc: "Specialized techniques to manage panic episodes and restore a sense of calm and control." },
  { icon: "HeartHandshake", title: "Relationship Issues", desc: "Confidential counseling for couples, family conflict and communication challenges." },
  { icon: "Battery", title: "Stress Management", desc: "Practical tools to manage work, study and life stress with sustainable coping strategies." },
  { icon: "Moon", title: "Sleep Problems", desc: "Evaluation and care for insomnia, disturbed sleep and sleep–anxiety cycles." },
  { icon: "Smile", title: "Emotional Well-being", desc: "Therapy focused on long-term emotional resilience, balance and self-awareness." },
  { icon: "Star", title: "Confidence Issues", desc: "Personalized sessions for self-esteem, performance anxiety and growth." },
];

export const STATS = [
  { value: "15+", label: "Years of Practice" },
  { value: "1000+", label: "Consultations" },
  { value: "Two", label: "Specialties" },
  { value: "Online", label: "& In-clinic" },
];

export const TRUST_BADGES = [
  { icon: "Award", text: "15+ Years Experience" },
  { icon: "Video", text: "Online Consultation" },
  { icon: "HeartHandshake", text: "Patient-Focused Care" },
  { icon: "MapPin", text: "Chandigarh Based" },
];

export const PAGES = [
  { path: "/", label: "Home" },
  { path: "/about", label: "About" },
  { path: "/neurology", label: "Neurology" },
  { path: "/psychology", label: "Psychology" },
  { path: "/online-consultation", label: "Online" },
  { path: "/patient-care", label: "Care" },
  { path: "/gallery", label: "Gallery" },
  { path: "/contact", label: "Contact" },
];
